import GamePredictionsStats from "./GamePredictionsStats";
import SinglePredictionsStats from "./SinglePredictionsStats";

export default class PredictionsStats {
  public single: SinglePredictionsStats = new SinglePredictionsStats();
  public topX: GamePredictionsStats = new GamePredictionsStats();
  public matchQuiz: GamePredictionsStats = new GamePredictionsStats();
}
